import React, { useEffect } from 'react';
import Layout from '@common/layout';
import Header from '@common/header';
import Footer from '@common/footer';
import Content from '@common/content';
import { PremiumCustomHead } from '@components/common/customHead';
import { useLogout, useUserInfo } from '@repository/auth/useUserInfo';
import Profile from '../../components/mypage/profile';
import SubMenu from '../../components/mypage/subMenu';
import PremiumInfo from '../../components/mypage/premium/PremiumInfo';
import styles from '../../components/mypage/premium/premium.module.scss';

import { ContentRouteUrl, ContentRouteUtil } from '@utils/routeUtil';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

const MyPagePremiumPage = () => {
  const { data: userData, isLoading } = useUserInfo();
  const isLogin = !!userData?.id;
  const { mutateAsync: logout } = useLogout();

  useEffect(() => {
    //isLoading이 없으면 useUserINnfo호출 전에 if문 실행됨.
    if (!isLoading && !isLogin) ContentRouteUtil.goLoginPage(ContentRouteUrl.MY_PAGE_PREMIUM);
  }, [isLogin]);

  return (
    <Layout>
      <PremiumCustomHead />
      <Header />
      <Content>
        {/* 상단 프로필 영역 */}
        <Profile userName={userData?.name} profileImageUrl={userData?.profileImageUrl} />

        {/* 마이 페이지 정보 영역 */}
        <div className={cx('wrap')}>
          {/* 좌측 메뉴 영역 */}
          <SubMenu page="premium" onLogout={logout} />

          {/* 우측 정보 영역 */}
          <PremiumInfo />
        </div>
      </Content>
      <Footer />
    </Layout>
  );
};

export default MyPagePremiumPage;
